import { render } from "./app-footer.vue?vue&type=template&id=51e5f5c5"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"

import "./app-footer.vue?vue&type=style&index=0&id=51e5f5c5&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__